export default "__VITE_ASSET__BJf3czcq__"